module.exports = __webpack_public_path__ + "img/the-herons-court.1279a7d8.webp";